import React from 'react';
import Content from '@/modules/common/components/Content';
import GridItem from '@/modules/common/components/GridItem';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import GridContainer from '@/modules/common/components/GridContainer';
import Alarm from './Alarm/Alarm';
import PostBacks from './PostBacks/PostBacks';
import '../styles/Settings.scss';

const breadcrumbs = [
    {name: 'Настройки'}
];

const Settings = () => {
    return (
        <Content id="settings">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><GridContainer>
                {/*<GridItem xs={12} md={6} xl={4}><Core/></GridItem>*/}
                <GridItem xs={12} md={6} lg={4} xl={3}><Alarm/></GridItem>
                <GridItem xs={12} md={6} lg={4} xl={3}><PostBacks/></GridItem>
            </GridContainer></ContentBody>
        </Content>
    );
};

export default Settings;
